import { useMemo } from 'react';

const isRemoteUrl = /^https?:\/\//i,

 getWebpSrc = (src) => {
    if (!src) return null;
    // 远程图片：追加 OSS webp 转换参数
    if (isRemoteUrl.test(src)) {
        if (src.includes('x-oss-process=image/format,webp')) return src;
        const separator = src.includes('?') ? '&' : '?';
        return `${src}${separator}x-oss-process=image/format,webp`;
    }
    return src;
},

 ImageRender = ({ src, alt = '', ...otherProps }) => {
    const webpSrc = useMemo(() => getWebpSrc(src), [src]);

    return (
        <picture style={{ display: 'contents' }}>
            {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
            <img loading="lazy" decoding="async" {...otherProps} src={src} alt={alt} />
        </picture>
    );
};

export default ImageRender;